import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { installDatadogErrorForwarding } from './dataDogLib';

const getClientToken = () => (import.meta as any).env.VITE_DATADOG_CLIENT_TOKEN as string | undefined;
const getApplicationId = () => (import.meta as any).env.VITE_DATADOG_APPLICATION_ID as string | undefined;
const getSite = () => (import.meta as any).env.VITE_DATADOG_SITE || 'us5.datadoghq.com';
const getEnv = () => (import.meta as any).env.VITE_MODE || 'dev';

const DD_SERVICE = 'kai-web';

export const initDatadog = () => {
  const clientToken = getClientToken();
  if (!clientToken) return;

  const site = getSite();
  const env = getEnv();

  datadogLogs.init({
    clientToken,
    site,
    service: DD_SERVICE,
    env,
    version: __APP_VERSION__,
    forwardErrorsToLogs: false, // handled by installDatadogErrorForwarding
    sessionSampleRate: 100,
  });

  const applicationId = getApplicationId();
  if (applicationId) {
    datadogRum.init({
      applicationId,
      clientToken,
      site,
      service: DD_SERVICE,
      env,
      version: __APP_VERSION__,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      plugins: [reactPlugin()],
      beforeSend: event => {
        // we have our own custom console logging interception and DDRum forwarding; this prevents duplicate errors from being sent to DDRum
        if (event.type === 'error' && event.error?.source === 'console') {
          return false;
        }
        return true;
      },
    });
  }

  installDatadogErrorForwarding();
};

export const setDatadogUser = (user: { id: string; name?: string; email?: string; orgId?: string }) => {
  datadogRum.setUser({
    id: user.id,
    name: user.name,
    email: user.email,
    orgId: user.orgId,
  });
};

export const logError = (error: Error, context?: Record<string, any>) => {
  if (!getClientToken()) return;

  datadogLogs.logger.error(error.message, {
    error: {
      kind: error.name,
      message: error.message,
      stack: error.stack,
    },
    ...context,
  }, error);
};

export const logInfo = (message: string, context?: Record<string, any>) => {
  if (!getClientToken()) return;

  datadogLogs.logger.info(message, context);
};
